$(function(){
	
	$(window).on('scroll', function() {
		var start = $(window).scrollTop() + window.innerHeight;
		var btn = $('.btn.follow.reserve');
		var footer = $('.shopify-section-group-footer-group.footer-utilities').offset().top;
		if (start <= footer) {
			btn.fadeIn();
		} else {
			btn.fadeOut();
		}
	});
  
});